import { RefObject } from 'react';
import { CareerPathwayCardProps } from '@/components/DesignSystem/Subsections/CareerPathwayPlanner/types';
import { createResultsEventContext } from '@/components/DynamicFlow/utils/createResultsEventContext';
import { EventingLocation } from '@/components/DynamicFlow/utils/types/types';
import { EventContext } from '@/components/DynamicFlow/utils/createEventingPayloadsDE';
import { createProductViewedPayload } from '@/components/DynamicFlow/utils/createEventingPayloadsDE';
import useViewEvents from '@/hooks/useViewEvent';
const CareerPathwayCard = ({
  subheader,
  title,
  description,
  destinationUrl,
  onProgramClick,
  logo,
  eventContext,
  itemViewCorrelationId,
  presets,
  programId,
}: CareerPathwayCardProps) => {
  const resultsEventContext = createResultsEventContext({
    eventContext: eventContext as EventContext,
    presets,
    location: EventingLocation.CAREER_PATHWAYS,
    productClickedCorrelationId: itemViewCorrelationId,
    viewCorrelationId: itemViewCorrelationId,
    brand: subheader,
    programId: programId,
    outboundUrl: destinationUrl,
  });
  const payload = createProductViewedPayload(resultsEventContext);

  const { ref } = useViewEvents([payload]);

  return (
    <div
      className='cursor-pointer bg-white rounded-lg border border-gray-200 p-3 shadow-sm not-prose hover:shadow-md transition-shadow w-full not-prose'
      onClick={(e) => {
        e.preventDefault();
        if (onProgramClick) {
          onProgramClick();
        }
      }}
      ref={ref as RefObject<HTMLDivElement>}
    >
      {/* College name */}
      <div className='text-xs text-gray-600  mb-1.5 font-bold'>{subheader}</div>

      {/* Degree title */}
      <span className='text-sm md:text-base font-bold text-gray-900'>
        {title}
      </span>

      {/* Description */}
      <p className='text-gray-600 text-xs mt-1 mb-2 text-ellipsis line-clamp-3'>
        {description}
      </p>

      <div className='flex items-center gap-3 justify-between'>
        {logo && (
          <div className='rounded-md p-2 border border-gray-200 -mb-6 shadow-md bg-white w-[100px] h-[57px]'>
            <img
              className='not-prose object-contain w-[84px] h-[41px]'
              src={logo}
              alt={`${subheader} Logo`}
              loading='lazy'
              decoding='async'
            />
          </div>
        )}
        {/* Learn more link */}
        {destinationUrl && (
          <button
            onClick={() => {
              window.open(destinationUrl, '_blank');
            }}
            className='text-white font-bold text-xs transition-colors inline-flex items-center justify-center whitespace-nowrap py-2 px-6 bg-primary-700 hover:bg-primary-800 rounded-md w-[114px] h-[34px]'
          >
            Learn more
          </button>
        )}
      </div>
    </div>
  );
};

export default CareerPathwayCard;
